import React from 'react';

import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useLocation, useNavigate } from "react-router-dom";

const TableList = ({ tikData }) => {
	const tikDataList = tikData;
	const titles = {
		"tik_num": "מספר תיק",
		"teurStatus": "סטטוס",
		"taarih_status": "תאריך סטטוס",
		"teurSugbakasha": "סוג בקשה",
		"mahut_bakasha": "מהות הבקשה",
	}

	const search = useLocation().search;
	const navigate = useNavigate();

	const LabeledDataItem = (label, value, dataItem, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			{
				dataItem !== undefined && field === "tik_num" ? 
					<div style={{ cursor: "pointer", color: "blue" }} onClick={() => openTiK(dataItem)}>
						{value}
					</div>
					: 
					<div className="value">{value}</div>
			}
		</div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.dataItem, props.field)}
		</td>
	}

	const DateCell = (props) => {
		const [year, month, day] = props.dataItem.taarih_status.split('T')[0].split('-');
		const cutomeData = `${day}/${month}/${year}`;

		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], cutomeData)}
		</td>
	}

	const openTiK = (tikDataItem) => {
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
		navigate(`/Details?TikNum=${tikDataItem.tik_num}&SystemCode=${systemCodeURL}&Page=BakashalInfo`);
	}

	return (
		<Grid data={tikDataList} >
			<GridColumn field="tik_num" title={titles.tik_num} cell={LabeledCell} />
			<GridColumn field="teurStatus" title={titles.teurStatus} cell={LabeledCell} />
			<GridColumn field="taarih_status" title={titles.taarih_status} cell={DateCell} />
			<GridColumn field="teurSugbakasha" title={titles.teurSugbakasha} cell={LabeledCell} />
			<GridColumn field="mahut_bakasha" title={titles.mahut_bakasha} cell={LabeledCell} />
		</Grid>
	)
}

export default TableList